<template>
  <div class="institution-entry">
    <div class="institution-grid">
      <div 
        v-for="(institution, index) in institutions" 
        :key="index" 
        class="institution-item"
      >
        <img 
          :src="institution.url" 
          :alt="institution.alt || '专业机构'"
          class="institution-logo"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstitutionEntry',
  props: {
    institutions: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style scoped>
.institution-entry {
  width: 100%;
}

.institution-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  align-items: center;
}

.institution-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.institution-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.institution-logo {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .institution-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .institution-item {
    padding: 15px;
  }
  
  .institution-logo {
    max-height: 60px;
  }
}

@media (max-width: 480px) {
  .institution-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .institution-item {
    padding: 12px;
  }
  
  .institution-logo {
    max-height: 50px;
  }
}
</style>